import React from 'react'
import { TextLink } from 'component-library/typography/TextLink/TextLink'

import { StyledFootnote } from 'component-library/publication/Footnote/Footnote.styled'

export interface Link {
    text: string
    href: string
    className?: string
}

export interface Props {
    text: string
    link?: Link
}

export const Footnote: React.FC<Props> = ({ text, link }) => {
    return (
        <StyledFootnote>
            {text}
            {link && (
                <TextLink href={link.href} className={link.className}>
                    {link.text}
                </TextLink>
            )}
        </StyledFootnote>
    )
}
